export enum FileType {
  CSV = 'text/csv',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  ALL_IMAGES = 'image/*',
  PDF = 'application/pdf',
  STREAM = 'application/octet-stream'
}

export enum ResponseContentType {
  BLOB = 'blob',
  ARRAY_BUFFER = 'arraybuffer',
  JSON = 'json',
  TEXT = 'text'
}

export enum ScreenName {
  TODO = 'To Do',
  ON_BOARD = 'Bulk Onboard',
  LEGAL_ENTITIES = 'Legal Entities',
  SEARCH = 'Search',
  EMPLOYEE_DETAILS = 'Member Details',
  PRODUCT_SOLUTIONS = 'Investment Solutions',
  MANAGE_USERS = 'Manage Users',
  BROADCAST_NOTIFICATION = 'Broadcast Notification',
  ADD_PRODUCT_SOLUTIONS = 'Add Investment Solutions',
  EDIT_PRODUCT_SOLUTIONS = 'Edit Investment Solutions',
  REPORTS = 'Reports'
}

export enum ApiErrorCodes {
  MOBILE_ALREADY_REGISTERED = 'This mobile number is already registered',
  EMAIL_ALREADY_REGISTERED = 'This email address is already registered',
  GENERIC_ERROR = 'There was an error, please try again',
  SERVER_ERROR = 'Oops, there was an error. We have logged it and our team will look into it. If this error is preventing you from completing something that is urgent, please contact our customer service team by clicking on the blue help support icon on the bottom right of your screen',
  BUSINESS_EXISTS = 'This business name already exists',
  EFT_EXISTS = 'This business already has an EFT payment method'
}

export enum GenericErrorCodes {
  DEFAULT_ERROR = 'There was an error. We have logged it and our team will look into it. If this error is preventing you from completing something that is urgent, please contact our customer service team by clicking on the blue help support icon on the bottom right of your screen'
}

export enum LegalEntityTypes {
  BUSINESS = 'Business',
  ASSET_MANAGER = 'Asset Manager',
  IFA = 'IFA',
  UNION = 'Union',
  WEALTH_MANAGER = 'Wealth Manager',
  HAYRICK = 'Hayrick'
}

export enum LegalEntityTypeIds {
  BUSINESS_ID = 'ba67c428-d1fb-4f66-9ad0-a2da3df4dc7c',
  ASSET_MANAGER_ID = '08d1ade9-d012-4e7f-a2ff-c283fc620d41',
  IFA_ID = '80d07ac5-f6b6-421a-9d30-c62b2d8d115e',
  UNION_ID = '7a168f25-747b-455f-8668-1242a2571120',
  WEALTH_MANAGER_ID = '634d7c6d-c3f2-4ae0-b241-a0a37d0e1d2f'
}

export enum UserRoleIds {
  CX_USER = 'F431F3B4-BB19-4D4F-9C45-9C91E4489FCE',
  FICA_VERIFY_USER = 'AF75AE59-4366-4799-89CE-2257882E7F7A',
  FICA_APPROVAL_USER = '0A9757AE-7023-4102-9043-BD12CEE8302F'
}

export enum RoleIds {
  BUSINESS_ADMIN_USER = '8d18aebe-fe00-4c1f-a931-4d8f937bf1a8',
  DIRECTOR = 'b1e7e0b7-8bb7-46e1-b03e-2fca37b5432c',
  BUSINESS_SUPER_USER = 'fc127563-3735-4312-aaf1-3c9ae032f44a',
  FICA_VERIFICATION_USER = '0a9757ae-7023-4102-9043-bd12cee8302f',
  SUPPORT_USER = '66104771-7ACC-4E7C-9EE2-450536C40F73'
}

export enum RouteURL {
  AUTH_SIGN_UP = 'auth/sign-up',
  AUTH_IDENTIFICATION_CHECK = 'auth/identification-check',
  AUTH_PASSCODE = 'auth/passcode',
  AUTH_FORGOT_PASSCODE = 'auth/forgot-passcode',
  AUTH_MOBILE_VALIDATION = 'auth/mobile-validation',
  AUTH_MOBILE_SUBMIT = 'auth/mobile-submit',
  AUTH_OTP = 'auth/otp',
  AUTH_FORGOT_PASSCODE_OTP = 'auth/forgot-passcode-otp',
  AUTH_MARKETING_OPTIONS = 'auth/marketing-options',

  TO_DO = 'todo',
  SEARCH = 'search',

  EMPLOYEE_DETAILS = '/employee/employee-details',

  BUSINESSES = 'businesses',
  BUSINESS_DETAIL = 'business-detail',

  PRODUCT_DETAIL = 'product-detail',

  INVITES = '/invites',

  LEGAL_ENTITIES = '/legal-entities',
  LEGAL_ENTITIES_OFFERINGS = '/legal-entities/offerings',
  LEGAL_ENTITIES_PRODUCTS = '/products',
  LEGAL_ENTITIES_MANAGE_PRODUCTS = '/legal-entities/manage-products',
  LEGAL_ENTITIES_PF_SETTINGS = '/legal-entities/pfsettings',
  LEGAL_ENTITIES_SETUP = '/legal-entity-setup',
  LEGAL_ENTITY_OVERVIEW = '/legal-entity-overview',
  LEGAL_ENTITY_DASHBOARD = '/entity-dashboard',

  ADD_CREDIT_CARD = 'add-credit-card',
  ADD_DEBIT_CARD = 'add-debit-card',

  PAYMENT_RUNS = 'payment-runs',
  MANAGE_EMPLOYEES = 'manage-employees',
  MANAGE_USERS = 'manage-users',
  MANAGE_PRODUCTS = 'manage-products',
  PRODUCT_CONFIGURATION = 'product-configuration',
  EMPLOYEE_INFORMATION = 'employee-information',
  EMPLOYEE_PRODUCTS = 'employee-products',
  EMPLOYEE_MANAGEMENT = 'employee-management',
  UPLOAD_HISTORY = 'upload-history',
  PAYMENT_MANDATE = 'payment-mandate',
  PAYMENT_MANDATE_CREDIT_CARD_MANDATE = 'payment-mandate/credit-card-mandate',
  PAYMENT_MANDATE_DEBIT_ORDER_MANDATE = 'payment-mandate/debit-order-mandate',

  PRODUCT_SETTINGS = 'product-settings',
  PRODUCT_SOLUTIONS = 'product-solutions',
  BROADCAST_NOTIFICATION = 'broadcast-notification',
  BROADCAST = 'broadcast',
  ADMIN_DASHBOARD = '/admin-dashboard',
  ENTITY_ADMIN_DASHBOARD = '/entity-admin-dashboard',
  ASQ_DASHBOARD = '/asq',
  EXCLUDE_DMA_ACCOUNTS = 'exclude-dma-accounts',
  WS_PAYROLL_UPLOAD = '/legal-entities/payroll-upload',
  PRODUCT_SOLUTIONS_ADD_SOLUTION = '/product-solutions/addSolution',
  PRODUCT_SOLUTIONS_EDIT_SOLUTION = '/product-solutions/editSolution',

  EMPLOYEE_GROUP_SETUP = 'employee-group-setup',

  PRODUCTS = 'products',

  MEMBER_ONBOARD = 'member-onboard',

  BROADCAST_MESSAGE = 'broadcast/broadcast-message',

  GROUPS = 'groups'
}

export enum SessionStorageIds {
  BUSINESS_ID = 'businessId',
  MANAGE_PRODUCT_NAME = 'manage-product-name',
  PRODUCT_ID = 'productId',
  LEGAL_ENTITY = 'legalEntity',
  LEGAL_ENTITIES = 'legal-entities',
  USER_MOBILE = 'user-mobile',
  TOKEN = 'token',
  REFRESH_TOKEN = 'refreshToken',
  PERMISSIONS = 'permissions',
  AUTH_PERMISSIONS = 'auth-permissions',
  AUTH_ROLES = 'auth-roles',
  AUTH_LEGAL_ENTITY_PERMISSIONS = 'auth-legal-entity-permissions',
  AUTH_CURRENT_LEGAL_ENTITY_ID = 'auth-current-legal-entity-id',
  PERMISSIONS_VERSION = 'permissions-version'
}

export enum UploadFileStatus {
  ARCHIVED = '3438f655-582c-49b1-b2b0-bf25cd1031eb',
  NOT_UPLOADED = 'd038c695-fc54-4a54-a854-3a4f4e4db473',
  PENDING = 'd6391e59-4749-4061-9e23-fb65a0349743',
  REPUDIATED = '43080925-362d-44ee-b0a7-b45a53d88fc5',
  VERIFIED = '4debf0d8-b0e4-4a44-9ca2-487b7ff1353b'
}

export enum CountryIds {
  SOUTH_AFRICA_ID = 'aa7bb822-9e8e-4bfa-ac09-112d7d6c6362'
}

export enum BusinessInviteStatuses {
  PENDING = '055AC270-BC4B-4B92-957D-AFDF2EFD183A',
  UNSENT = 'D0B9CBC6-854B-4794-983D-81CE1466D7D3'
}

export enum ToDoIds {
  CHOOSE_PF_DEFAULT_INVESTMENT_SOLUTION = '40734582-0c27-4e25-b41c-1f694045c1df',
  PF_SETTINGS = '5f24345d-030f-4fda-b679-dfcc1a265b72'
}

export enum NotificationTypeId {
  CHOOSE_PF_DEFAULT_INVESTMENT_SOLUTION = '88f118d7-aa78-4dd1-bf5e-338d7da1982a',
  PF_SETTINGS = '3d871572-7b60-44e8-aad4-656046ba4fc4',
  CAPTURE_DMA_SUBHOUSE = 'b60e431c-8feb-4b8b-8144-8f636db95fea'
}

export enum NavigateTos {
  VERIFY_SELFIE = '708E8AFF-85CA-4202-B3D4-69000B9659D5',
  VERIFY_PROOF_OF_IDENTITY = 'F33CC15F-1ABA-4E6D-ADDD-153C10018960',
  VERIFY_PROOF_OF_BANKING = 'FFE5CC98-8755-4061-9AD9-2F62390165A2',
  VERIFY_PROOF_OF_ADDRESS = 'D0EBD1AC-0E81-4D87-959F-8D2142CCB91E',
  PORTFOLIO_SWITCH = 'E49176BF-E785-4F47-87C2-1CB1B804E4D0',
  WITHDRAWAL = 'DD9D2B87-171C-4A99-9CEF-1BAA998265A0',
  CONTRIBUTION_CHANGE_APPROVAL = 'C0A7F3B2-5D64-4E19-8F27-9B3E6C1A42D8'
}